// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZP-z","hovered":"_P-z","hoverImage":"aQ-z","mainImage":"bQ-z","imageNoBackground":"cQ-z","fullSizeImage":"dQ-z"};